import React from 'react';

const ListNoResults = (props) => (
	<div className="pickup__message-container">
		<p className="pickup__message">{props.message}</p>
	</div>
);

export default ListNoResults;
